export default __webpack_public_path__ + "static/media/fitzon_banner.585e4ff9.jpg";